<template>
  <div
    class="CustomReportWrap mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="leftMenu">
      <CustomMenu @changeMenu="changeMenu" />
    </div>
    <div class="rightContent commonWrap">
      <FormContent
        :activeItem="activeItem"
        :showDownload="judgeAuthority('baobiao:customReport:export')"
        @openAddForm="openAddForm"
        ref="formComponent"
      />
    </div>

    <AddFormTemplate
      v-if="dialogFormVisible"
      :addFormItem="addFormItem"
      @handleRenewFun="handleRenewFun"
    />
  </div>
</template>

<script>
import { judgeAuthority } from "@/assets/js/utils";
import CustomMenu from "@/components/baobiaoguanli/CustomMenu";
import AddFormTemplate from "@/components/baobiaoguanli/AddFormTemplate.vue";
import FormContent from "@/components/baobiaoguanli/FormContent.vue";
export default {
  components: {
    CustomMenu,
    AddFormTemplate,
    FormContent,
  },
  data() {
    return {
      dialogFormVisible: false,
      addFormItem: {},
      activeItem: {},
    };
  },
  methods: {
    judgeAuthority,
    changeMenu(val) {
      let treeList = [];
      val.treeValue.map((v) => {
        treeList.push({ id: v.id, dis_name: v.name });
      });
      this.activeItem = {
        key: val.typeKey,
        ydata: treeList,
      };
    },
    handleRenewFun(name) {
      this.$refs.formComponent.exportExcel(name);
      this.dialogFormVisible = false;
    },

    openAddForm(item) {
      this.addFormItem = item;
      this.dialogFormVisible = true;
    },
  },
  created() {},
};
</script>

<style lang="scss" scoped>
.CustomReportWrap {
  @include setFlexBetween;
  .leftMenu {
    @include setMenuWH;
  }
  .rightContent {
    @include setCenterWH;
  }
}
</style>
